import {HeaderButtonCommonProps} from '@/shared/components/Header';
import {TIARA_ACTION} from '@/shared/constants/tiara';

const SettingButton = ({onClick, trackEvent}: HeaderButtonCommonProps) => {
  return (
    <button
      type="button"
      className="btn_setting"
      onClick={(e) => {
        trackEvent({action: TIARA_ACTION.SETTING_CLICK});
        onClick?.(e);
      }}
    >
      <span className="icon icon_setting">설정</span>
    </button>
  );
};
export default SettingButton;
